module.exports = __webpack_public_path__ + "media/iso-large.db47e1fd.mp4";